const state = {
  projects: {},
  emmisionValue: 0
};

const getters = {
  getProjects: state => state.projects,
  getToken: state => state.token,
  getEmmisionValue: state => state.emmisionValue
};

const actions = {
  setProjects({ commit }, projects) {
    commit('setUser', projects);
  },
  addProject({ commit }, projects) {
    commit('setUser', projects);
  },
  setEmmisionValue({ commit }, emmisionValue) {
    commit('setEmmisionValue', emmisionValue);
  }
};

const mutations = {
  setProjects: (state, projects) => (state.projects = projects),
  addProject: (state, project) => state.projects.append(project),
  setEmmisionValue: (state, emmisionValue) =>
    (state.emmisionValue = emmisionValue)
};

export default {
  state,
  getters,
  actions,
  mutations
};
